import Vue from 'vue'
import VueRouter from 'vue-router'
import userService from '../services/user.service'
Vue.use(VueRouter)

const routes = [

  // {
  //   path: '/',
  //   name: 'proximamente',
  //   component: () => import('../views/proximamente/proximamente.vue'),
  //   meta: {
  //     log: false,
  //     admin: false,

  //     auth: false,
  //   }
  // },

  {
    path: '/inicio',
    name: 'inicio',
    component: () => import('../views/Home'),
    meta: {
      log: false,
      admin: false,

      auth: false,
    }
  },
  {
    path: '/inicio/en',
    name: 'inicioEn',
    component: () => import('../views/HomeEn'),
    meta: {
      log: false,
      admin: false,

      auth: false,
    }
  },

  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login'),
    meta: {
      log: false,
      admin: false,

      auth: false,
    }
  },

  {
    path: '/auth',
    name: 'autentificacion',
    component: () => import('../views/Autentificacion'),
    meta: {
      log: true,
      admin: true,

      auth: false
    }
  },

  {
    path: '/administrador',
    name: 'Dashboard',
    component: () => import('../views/adminWrapper'),
    meta: {
      log: true,
      admin: true,

      auth: true,
    }
  },

  {
    path: '/servicio/implantes-dentales',
    name: 'servicio implantes dentales',
    component: () => import('../views/servicioImplantesDentales'),
    meta: {
      log: false,
      admin: false,

      auth: false,
    }
  },
  {
    path: '/servicio/implantes-dentales/en',
    name: 'servicio implantes dentales',
    component: () => import('../views/servicioImplantesDentales'),
    meta: {
      log: false,
      admin: false,

      auth: false,
    }
  },

  // {
  //   path: '/aviso-de-privacidad',
  //   name: 'Aviso de privacidad',
  //   component: () => import('../views/Aviso'),
  //   meta: {
  //     log: false,
  //     admin: false,

  //     auth: false,
  //   }
  // },

  // {
  //   path: '/terminos-condiciones',
  //   name: 'Terminos y condiciones de uso',
  //   component: () => import('../views/Terminos'),
  //   meta: {
  //     log: false,
  //     admin: false,

  //     auth: false,
  //   }
  // },

  {
    path: '/',
    name: 'proximamente',
    component: () => import('../views/proximamente'),
    meta: {
      log: false,
      admin: false,

      auth: false
    }
  },


]




const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})



router.beforeEach(async (to, from, next) => {

  let meta_admin = to.matched.some(record => record.meta.admin);

  let meta_log = to.matched.some(record => record.meta.log);
  let meta_auth = to.matched.some(record => record.meta.auth);

  let tokenexp = await userService.tokenexp()
  let check = false //comprobar si esta logeado
  let admin = false;

  let type = ''

  if (tokenexp) { // ver que el token no este expirado.
    localStorage.removeItem('tkn')
    localStorage.removeItem('ath') //limpiar el localstorage
    next()
  }


  let response = await userService.getData()

  if (response.status == 'error') {
    localStorage.removeItem('tkn')
    localStorage.removeItem('ath')
  }


  if (response.success) { //comprobar que sea un login valido.
    check = true;
    let isAdmin = userService.isAdmin(response.data);
    admin = isAdmin.admin;
    type = isAdmin.type;
  }

  let ath = await userService.getAth();

  // borrar el localstorage cada que vayamos a login.

  if (to.path === '/login' && check) {
    localStorage.removeItem('tkn')
    localStorage.removeItem('ath')

    next()
  }

  //redireccionamientos por rol.
  if (!meta_log) next();

  if (meta_log && !check) next('/login');

  if (meta_admin) {
    if (admin) {

      if (meta_auth) {
        if (ath) {
          next();
        } else {
          localStorage.removeItem('tkn')
          localStorage.removeItem('ath')
          next('/login')
        }
      } else { //...proximamente rutas que no requieran autentificacion
        next()
      }

    } else {
      localStorage.removeItem('tkn')
      localStorage.removeItem('ath')
      next('/')
    }
  } else {
    next()
  }

  if (to.hash) {

    const checkExist = setInterval(() => {
      const element = document.querySelector(to.hash);
      if (element) {
        clearInterval(checkExist);
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
    next();
  }

  if (to.path === from.path) {
    window.scrollTo(0, 0);
  }
  next();


  window.scrollTo({ top: 0, behavior: "instant" });
  next();
});




export default router

